import { PayloadAction } from "@reduxjs/toolkit";
import { IStationInfo } from 'dataSources/Typicode/stations/types/stationInfo';

import { IState } from "../types";

const setStationInfo = (state: IState, action: PayloadAction<Partial<IStationInfo>>) => {
  state.stationInfo = action.payload;
};

export default setStationInfo;